module.exports = __webpack_public_path__ + "img/ez-cms-horizontal.88fb86fe.png";